import { render, staticRenderFns } from "./irrigationAddArea.vue?vue&type=template&id=f2f9ed60&scoped=true&"
import script from "./irrigationAddArea.vue?vue&type=script&lang=ts&"
export * from "./irrigationAddArea.vue?vue&type=script&lang=ts&"
import style0 from "./irrigationAddArea.vue?vue&type=style&index=0&id=f2f9ed60&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2f9ed60",
  null
  
)

export default component.exports